import { IRest } from "./rest.interface";
import { EnumInstituteJurisdiction } from "./enums";

export class Institute implements IRest {
    className = 'Instituição';

    id!: number;
    name!: string;
    fullName!: string;
    link!: string;
    jurisdiction!: EnumInstituteJurisdiction;
    image!: string; //Uso Interno

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            id: this.id || undefined,
            name: this.name,
            fullname: this.fullName,
            link: this.link,
            jurisdiction: this.jurisdiction
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.id = data['id'] || 0;
            this.name = data['name'] || '';
            this.fullName = data['fullname'] || '';
            this.link = data['link'] || '';
            this.jurisdiction = <EnumInstituteJurisdiction>(data['jurisdiction'] || '');
        }
        return this;
    }

}

export class InstituteImage implements IRest {
    className = 'Imagem da Instituição';

    instituteId!: number;
    image!: string;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            image: this.image
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.instituteId = data['instituteId'] || 0;
            this.image = data['image'] || '';
        }
        return this;
    }

}